import { useEffect, useState } from 'react';

/**
 * Custom hook that replicates the CSS clamp logic for syn-trade-right width
 * Original CSS: width: clamp(340px, calc(340px + (460px - 340px) * ((var(--doc-width) - 1440px) / (2560px - 1440px))), 460px);
 */
export const useResponsiveTradeWidth = (minWidth = 340, maxWidth = 460, minBreakpoint = 1440, maxBreakpoint = 2560) => {
  const [width, setWidth] = useState<number>(340);

  useEffect(() => {
    const calculateWidth = () => {
      const docWidth = window.innerWidth;

      // Only apply responsive width for screens >= 1440px
      if (docWidth < minBreakpoint) {
        setWidth(minWidth); // Default width for smaller screens
        return;
      }

      // Clamp calculation: clamp(340px, calc(340px + (460px - 340px) * ((docWidth - 1440px) / (2560px - 1440px))), 460px)

      // Calculate the interpolated value
      const progress = (docWidth - minBreakpoint) / (maxBreakpoint - minBreakpoint);
      const calculatedWidth = minWidth + (maxWidth - minWidth) * progress;

      // Apply clamp logic (min: 340px, max: 460px)
      const clampedWidth = Math.max(minWidth, Math.min(maxWidth, calculatedWidth));

      setWidth(clampedWidth);
    };

    // Calculate initial width
    calculateWidth();

    // Add resize listener
    window.addEventListener('resize', calculateWidth);

    // Cleanup
    return () => {
      window.removeEventListener('resize', calculateWidth);
    };
  }, [maxBreakpoint, maxWidth, minBreakpoint, minWidth]);

  return {
    width,
    style: {
      width: `${width}px`,
      maxWidth: maxWidth,
    },
  };
};
